import styled from "styled-components";

interface SelectProps {
  padded: boolean;
  focused: boolean;
  error: string | null;
  direction: "ltr" | "rtl";
}

const Select = styled.select<SelectProps>`
  background: none;
  border: none;
  outline: none;
  appearance: none;

  font-family: ${(props) => props.theme.fonts.body.family};
  font-size: ${(props) => props.theme.fonts.body.fontSize};
  line-height: ${(props) => props.theme.fonts.body.lineHeight};
  font-weight: ${(props) => props.theme.fonts.body.fontWeight};
  letter-spacing: ${(props) => props.theme.fonts.body.letterSpacing};
  color: ${({ theme }) => theme.colors.typographyDefault};

  border-radius: ${({ theme }) => theme.borderRadiusInput};
  box-sizing: border-box;
  padding: ${({ theme }) => theme.paddingSelect};
  padding-left: ${({ padded, theme, direction }) =>
    direction === "ltr"
      ? padded
        ? theme.paddingSelectWithFlagLeft
        : theme.paddingSelectLeft
      : "initial"};
  padding-right: ${({ padded, theme, direction }) =>
    direction === "rtl"
      ? padded
        ? theme.paddingSelectWithFlagLeft
        : theme.paddingSelectLeft
      : "initial"};

  border-top: ${({ theme, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-left: ${({ theme, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-right: ${({ theme, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-bottom: ${({ theme, error, focused }) => {
    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};
`;

export default Select;
